/* tslint:disable */

/**
 */
export class CompanyInput {
    style_search?: string;
    key_input?: string;
}
